import fr from './fr.json'
import terms from './terms'

const messages = {
  ...fr,
  terms,
}

export default messages
